import NoContentMessage from "@/components/NoContentMessage";
import styles from "@/styles/Search.module.scss";

export default function SearchNoResults({ searchQuery }) {
  let text =
    "スポーツの競技名やチーム名、アーティスト名、番組タイトル、出演者などを入れて検索してください。";

  return (
    <NoContentMessage>
      <div className={styles.noresults}>
        {searchQuery && searchQuery.length > 0 && (
          <h3>「{searchQuery}」に一致する番組がありませんでした。</h3>
        )}
        <p>
          <span className="fa fa-exclamation-circle" />
          ヒント
        </p>
        <ul>
          <li>キーワードを変えて検索してください</li>
          <li>{text}</li>
        </ul>
      </div>
    </NoContentMessage>
  );
}
